export const SEARCH_DEBOUNCE_TIME_IN_MS = 500;
export const SEARCH_MINIMUM_LENGTH = 2;
